import {
  Action,
  classType,
  DashboardInitialState,
  departmentType,
  flattenSubclassListType,
  subClassType
} from "../interface";
import { sortList } from "src/utils/genericFunctions";
import dayjs from "dayjs";
import { ApiStatus } from "src/config/enums/genericEnums";

export const initialState: DashboardInitialState = {
  departmentList: [],
  classList: [],
  subClassList: [],
  department: "all",
  departmentId: "",
  sync: false,
  lastSyncedTime: dayjs().format("hh:mm A, MM/DD/YY"),
  masterList: null,
  filters: null,
  isCustomizationActive: false,
  tiles: {
    status: ApiStatus.IDLE,
    dashboardTiles: [],
    customizerTiles: []
  }
};

export const getCurrentDepartmentByValue = (
  departments: any[],
  currentValue: any
) =>
  departments.find(
    (eachDepartment: { value: any }) => eachDepartment.value === currentValue
  );

export const handleUpdateDepartment = (
  state: DashboardInitialState,
  action: Action
) => {
  if (state.departmentList.length < 1) return state;
  const { value, id } = getCurrentDepartmentByValue(
    state.departmentList,
    action.payload.department
  );
  state.departmentId = id;
  state.department = value;
  state.lastSyncedTime = dayjs().format("hh:mm A, MM/DD/YY");
};

export const handleUpdateSyncData = (state: DashboardInitialState) => {
  state.sync = !state.sync;
  state.lastSyncedTime = dayjs().format("hh:mm A, MM/DD/YY");
};

export const handleUpdateCustomizerFlag = (
  state: DashboardInitialState,
  action: Action
) => {
  state.isCustomizationActive = action.payload;
};

export const getFormatedDepartmentFromMasterList = (departments: any) => {
  const departmentList = departments?.map(
    ({ name, id }: { name: string; id: number }) => ({
      name,
      id: id.toString(),
      value: name.toLowerCase()
    })
  );

  departmentList.unshift({
    name: "All Departments",
    value: "all",
    id: ""
  });
  return sortList(departmentList, "name");
};

export const getFormatedClassSubClassFromMasterList = (departments: any) => {
  const subClassList: any[] = [];
  const classList: any[] = [];
  departments?.forEach((department: any) => {
    department?.classes?.forEach((clas: any) => {
      classList.push({
        ...clas,
        departmentId: department.id
      });

      clas?.subClasses?.forEach((subClass: any) => {
        subClassList.push({ ...subClass, classId: clas.id });
      });
    });
    return department?.classes;
  });
  return {
    subClassList: sortList(subClassList, "name"),
    classList: sortList(classList, "name")
  };
};

export const getFlatternSubClass = (
  departments: departmentType[]
): flattenSubclassListType[] => {
  if (departments?.length < 1) return [];
  const flattenSubclassList: flattenSubclassListType[] = [];
  departments?.forEach((department) => {
    department.classes.forEach((clas: classType) => {
      clas.subClasses.forEach((subClass: subClassType) => {
        flattenSubclassList.push({
          departmentId: department.id,
          departmentName: department.name,
          classId: clas.id,
          className: clas.name,
          subClassId: subClass.id,
          subClassName: subClass.name
        });
      });
    });
  });

  return flattenSubclassList;
};

export const handleFullFilledForFetchMasterList = (
  state: DashboardInitialState,
  action: any
) => {
  const { data } = action.payload;
  const departmentList = getFormatedDepartmentFromMasterList(data?.departments);
  const { subClassList, classList } = getFormatedClassSubClassFromMasterList(
    data?.departments
  );
  const flattenSubclassList = getFlatternSubClass(data?.departments);

  localStorage.setItem("departmentList", JSON.stringify(departmentList));
  state.departmentList = departmentList;
  state.classList = classList;
  state.subClassList = subClassList;
  state.department = "all";
  state.departmentId = "";
  state.masterList = data;
  state.flattenSubclassList = flattenSubclassList;
};

export const handleFullfilledForFetchFilterList = (
  state: DashboardInitialState,
  action: any
) => {
  state.filters = action.payload.data;
};

export const handlePendingForFetchTilesData = (
  state: DashboardInitialState
) => {
  state.tiles = {
    status: ApiStatus.PENDING,
    dashboardTiles: [],
    customizerTiles: []
  };
};

export const handleFullfilledForFetchTilesData = (
  state: DashboardInitialState,
  action: any
) => {
  const { dashboardTiles, customizerTiles } = action.payload;

  state.tiles = {
    status: ApiStatus.IDLE,
    dashboardTiles: dashboardTiles?.data,
    customizerTiles: customizerTiles?.data
  };
};
